// extracted by mini-css-extract-plugin
export default {"tag":"tag-09fa","large":"large-cfba","relative":"relative-3dff","heart-icon":"heart-icon-0115"};